<template>
  <div
    :class="{
      'f-message': true,
      'is-from-current-user': message.isFromCurrentUser
    }">
    <div class="f-message-info">
      <span class="author">
        {{ message.author }}
      </span>
      <span class="time">
        {{ formatDate(message.created_at) }}
      </span>
    </div>
    <div :class="{
      'f-message-content': true,
    }">
      <div>
        {{ message.message }}
      </div>

      <template v-if="message.files.length">
        <div
          v-for="(file, index) of message.files"
          :key="'message-'+ message.id + '-file-' + index"
          :class="{
            'f-message-attachment flex': true,
            'mt-2 mt-4-ms': index === 0,
            'mt-1 mt-3-ms': index !== 0,
          }">
          <f-button
            class="no-shrink mb-2-ms"
            :disabled="actionInProgress"
            theme="inverted-light"
            @click.prevent="downloadFile(file)">
            <span class="flex flex-align-items-center text-center">
              <f-icon name="attachment" />
              <span class="break-word">{{ file.file }}</span>
            </span>
          </f-button>
          <span
            v-if="file.description"
            class="ml-2 ml-0-ms break-word my-auto line-height-small">
            {{ file.description }}
          </span>
        </div>
      </template>
    </div>
    <div
      v-if="message.isFromCurrentUser"
      class="status small">
      <template v-if="message.read_at">
       {{ $t('message.read') }}: {{ formatDate(message.read_at) }}
      </template>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';

export default {
  name: 'f-message',
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      actionInProgress: false
    };
  },
  methods: {
    formatDate (date) {
      if (!date) {
        return this.$t('ui.none');
      }

      let dateObject = new Date(date);

      return [
        dateObject.getDate(),
        dateObject.getMonth() + 1,
        dateObject.getFullYear()
      ].map(n => n < 10 ? '0' + n : n).join('.') + ', ' + [
        dateObject.getHours(),
        dateObject.getMinutes()
      ].map(n => n < 10 ? '0' + n : n).join('.');
    },
    downloadFile (file) {
      this.actionInProgress = true;
      let endpointUrl = this.message.downloadFileEndpoint + file.id;

      this.$http.get(endpointUrl, {
        responseType: 'blob',
      }).then(response => {
        if (response.status === 200) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', file.file);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          this.actionInProgress = false;
        } else {
          Vue.swal({
            title: this.$t('inquiryFiles.downloadFileError'),
            html: this.$t('ui.tryAgain'),
            icon: 'warning',
            confirmButtonText: 'OK',
            buttonsStyling: true
          });
          this.actionInProgress = false;
        }
      }).catch(error => {
        console.log(error);
        Vue.swal({
          title: this.$t('inquiryFiles.downloadFileError'),
          html: this.$t('ui.tryAgain'),
          icon: 'warning',
          confirmButtonText: 'OK',
          buttonsStyling: true
        });
        this.actionInProgress = false;
      });
    }
  }
}
</script>
